// extracted by mini-css-extract-plugin
module.exports = {"container":"TechInfo-module--container--2f7PP","rotate":"TechInfo-module--rotate--1R8Mi"};